import L from "leaflet";
import carIcon from "@/assets/vehicles/glazy-car-yellow.png";
import pcxIcon from "@/assets/vehicles/glazy-pcx5-yellow.png";
import truckIcon from "@/assets/vehicles/glazy-truck-yellow.png";
import { STATUS, vehicleStatus } from "@/lib/fleet";

const esc = (s) =>
  String(s ?? "").replace(/[&<>"']/g, (c) =>
    ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[c])
  );

/*
 * Ikon kendaraan Glazy Tracker
 * type:
 *   motorcycle / motor / bike -> motor
 *   selain itu               -> mobil
 */

function vehicleImage(v) {
  const type = String(v.type || "").toLowerCase();

  if (type === "motorcycle" || type === "motor" || type === "bike") {
    return pcxIcon;
  }

  if (type === "truck") {
    return truckIcon;
  }

  return carIcon;
}

export function vehicleIcon(v, selected, showLabel = true) {
  const st = vehicleStatus(v);
  const c = STATUS[st].hex;

  const rotation = Number(v.direction || 0);
  const image = vehicleImage(v);

  const inner = `
    <img
      src="${image}"
      alt=""
      style="
        width:32px;
        height:44px;
        object-fit:contain;
        transform:rotate(${rotation}deg);
        transform-origin:center;
        display:block;
      "
    />
  `;

  return L.divIcon({
    className: "gt-marker-wrap",
    iconSize: [46, 46],
    iconAnchor: [23, 23],

    html: `
      <div
        class="gt-marker${selected ? " gt-selected" : ""}"
        style="--c:${c}"
      >
        ${
          st === "moving"
            ? '<span class="gt-pulse"></span>'
            : ""
        }

        <div class="gt-core">
          ${inner}
        </div>

        ${
          showLabel
            ? `<div class="gt-tag">${esc(v.plate)}</div>`
            : ""
        }
      </div>
    `,
  });
}

const PINS = {
  start: ["#10B981", "A"],
  end: ["#EF4444", "B"],
  stop: ["#3B82F6", "P"],
};

export function pinIcon(kind) {
  const [c, t] = PINS[kind];

  return L.divIcon({
    className: "gt-marker-wrap",
    iconSize: [26, 26],
    iconAnchor: [13, 13],
    html: `
      <div
        class="gt-pin"
        style="background:${c}"
      >
        ${t}
      </div>
    `,
  });
}

export const clusterIcon = (cluster) =>
  L.divIcon({
    html: `
      <div class="gt-cluster">
        ${cluster.getChildCount()}
      </div>
    `,
    className: "gt-cluster-wrap",
    iconSize: [42, 42],
  });

export function drawRoute(
  map,
  positions,
  { stops = [], color = "#EAB308" } = {}
) {
  const group = L.layerGroup().addTo(map);

  if (!positions.length) return group;

  const latlngs = positions.map((p) => [p.lat, p.lng]);

  L.polyline(latlngs, {
    color: "#0A0D12",
    weight: 8,
    opacity: 0.35,
  }).addTo(group);

  L.polyline(latlngs, {
    color,
    weight: 4.5,
    opacity: 0.95,
    lineJoin: "round",
  }).addTo(group);

  L.marker(latlngs[0], {
    icon: pinIcon("start"),
  })
    .bindTooltip("Start")
    .addTo(group);

  L.marker(latlngs[latlngs.length - 1], {
    icon: pinIcon("end"),
  })
    .bindTooltip("End")
    .addTo(group);

  stops.forEach((s) =>
    L.marker([s.lat, s.lng], {
      icon: pinIcon("stop"),
    })
      .bindTooltip(
        `Berhenti ${Math.round(s.duration_s / 60)} mnt`
      )
      .addTo(group)
  );

  map.fitBounds(
    L.latLngBounds(latlngs).pad(0.15)
  );

  return group;
}
